'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _reactRouter = require('react-router');

var _auth = require('selectors/auth');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./NewProject.scss');

var newAudioImg = require('./new-audio.png');
var newVideoImg = require('./new-video.png');
var newFromSSImg = require('./new-from-ss.png');
var newSSImg = require('./new-ss.png');
var newNewsletterImg = require('./new-newsletter.png');

var NewProject = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    permissions: (0, _auth.getPermissions)(state)
  };
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(NewProject, _Component);

  function NewProject() {
    (0, _classCallCheck3.default)(this, NewProject);
    return (0, _possibleConstructorReturn3.default)(this, (NewProject.__proto__ || (0, _getPrototypeOf2.default)(NewProject)).apply(this, arguments));
  }

  (0, _createClass3.default)(NewProject, [{
    key: 'onVideoClick',
    value: function onVideoClick() {
      var t = this.context.t;

      _toastr2.default.info(t('Currently Unavailable'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          permissions = _props.permissions;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('Create New Project') }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Create New Project')
          ),
          permissions.createSharespace && _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.panel, to: '/projects/sharespace/0' },
            _react2.default.createElement(
              'div',
              { className: styles.thumb },
              _react2.default.createElement('img', { src: newSSImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.descr },
              _react2.default.createElement(
                'h3',
                { className: styles.header },
                t('Sharespace')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Upload content and allow other people in your organization to share & create projects')
              )
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.panel, to: '/projects/sharespace' },
            _react2.default.createElement(
              'div',
              { className: styles.thumb },
              _react2.default.createElement('img', { src: newFromSSImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.descr },
              _react2.default.createElement(
                'h3',
                { className: styles.header },
                t('Create project from sharespace')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Use an existing Sharespace to create a project')
              )
            )
          ),
          permissions.createProject && _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.panel, to: '/projects/audio/0' },
            _react2.default.createElement(
              'div',
              { className: styles.thumb },
              _react2.default.createElement('img', { src: newAudioImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.descr },
              _react2.default.createElement(
                'h3',
                { className: styles.header },
                t('Audio')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Create a new audio project')
              )
            )
          ),
          permissions.createProject && _react2.default.createElement(
            'a',
            { className: styles.panel, onClick: this.onVideoClick },
            _react2.default.createElement(
              'div',
              { className: styles.thumb },
              _react2.default.createElement('img', { src: newVideoImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.descr },
              _react2.default.createElement(
                'h3',
                { className: styles.header },
                t('Video')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Create a new video project')
              )
            )
          ),
          permissions.createNewsletter && _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.panel, to: '/projects/newsletter/0' },
            _react2.default.createElement(
              'div',
              { className: styles.thumb },
              _react2.default.createElement('img', { src: newNewsletterImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.descr },
              _react2.default.createElement(
                'h3',
                { className: styles.header },
                t('Newsletter')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Create a beautiful newsletter based on your existing projects')
              )
            )
          )
        )
      );
    }
  }]);
  return NewProject;
}(_react.Component), _class3.propTypes = {
  permissions: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onVideoClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVideoClick'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = NewProject;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NewProject/NewProject.js
// module id = 2176
// module chunks = 1